import ScreenWrapper from "@/components/ScreenWrapper"
import { useAuthStore } from "@/stores/useAuthStore"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import {
  createRootRoute,
  Outlet,
  redirect,
  useRouter,
} from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import { ToastContainer } from "react-toastify"
import { ErrorBoundary, NotFoundScreen } from "toptaal-shared"

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    const { token, refreshToken } = useAuthStore.getState()

    const openPaths = ["/login", "/auth"]

    if (
      !refreshToken &&
      !token &&
      !openPaths.some((path) => location.pathname.startsWith(path))
    ) {
      throw redirect({ to: "/login" })
    }
  },
  component: RootComponent,
  notFoundComponent: () => (
    <ScreenWrapper className="screen-height-minus-navbar flex items-center justify-center !px-4 md:!px-8 !max-w-none bg-primary-light-blue relative overflow-hidden">
      <NotFoundScreen />
    </ScreenWrapper>
  ),
})

function RootComponent() {
  const router = useRouter()

  return (
    <ErrorBoundary
      ScreenWrapper={ScreenWrapper}
      navigateHome={() =>
        router.navigate({
          to: "/",
          replace: true,
        })
      }
      navigateBack={() => {
        router.history.back()
      }}
    >
      <Outlet />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="light"
        limit={3}
      />
      <TanStackRouterDevtools position="bottom-left" />
      <ReactQueryDevtools initialIsOpen={false} />
    </ErrorBoundary>
  )
}
